import React from "react";
import "./LoadingBar.css";

const LoadingBar = ({
  text = "Loading...",
  size = "normal",
  fullScreen = false,
}) => {
  return (
    <div
      className={`loading-bar-container ${size} ${
        fullScreen ? "fullscreen" : ""
      }`}
    >
      {text && <p className="loading-bar-text">{text}</p>}
      <div className="loading-bar">
        <div className="loading-bar-fill"></div>
      </div>
    </div>
  );
};

export default LoadingBar;

//COMMENT ADDED
//COMMENT ADDED
